<template>
    <header id="header">
        <h1>{{ header }}</h1>
        <div v-html="text"></div>
    </header>
</template>

<script>
export default {
    name: 'app-header',
    data () {
        return {
            header: 'Stats50 Gallery',
            text: 'Event\'s Photo Gallery',

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/gallery/AppHeader.vue?7f531dc7